import React from 'react';
import {
    Activity,
    ActivityIcon,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    Archive,
    AreaChart,
    Armchair,
    ArrowDown,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowRightLeft,
    ArrowUp,
    Atom,
    Baby,
    Badge,
    BadgeCheck,
    Ban,
    Banknote,
    BarChart,
    BarChart3,
    Barcode,
    Beaker,
    Bed,
    BedDouble,
    Bell,
    BellOff,
    Bluetooth,
    Book,
    BookOpen,
    Box,
    Brain,
    Briefcase,
    Bug,
    Building,
    Building2,
    Calculator,
    Calendar,
    CalendarDays,
    CalendarPlus,
    CalendarRange,
    Camera,
    Check,
    CheckCheck,
    CheckCircle,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Chrome,
    Circle,
    CircleDot,
    CircleHelp,
    Clipboard,
    ClipboardCheck,
    ClipboardList,
    Clock,
    Cloud,
    CloudUpload,
    Code,
    Coffee,
    Cog,
    Columns,
    Combine,
    Command,
    Component,
    Computer,
    Contact,
    Container,
    Contrast,
    Copy,
    CreditCard,
    Cross,
    Crown,
    Currency,
    Database,
    Delete,
    Diamond,
    Diff,
    Dock,
    DollarSign,
    DoorOpen,
    Dot,
    Download,
    Drill,
    Droplet,
    Droplets,
    Ear,
    Edit,
    Edit2,
    Edit3,
    Expand,
    ExternalLink,
    Eye,
    EyeOff,
    File,
    FileCheck,
    FileDown,
    FileEdit,
    FileImage,
    FilePlus,
    FileSpreadsheet,
    FileText,
    Files,
    Film,
    Filter,
    Fingerprint,
    Flag,
    FlaskConical,
    Focus,
    FolderOpen,
    Forward,
    Fullscreen,
    Gauge,
    GlassWater,
    Grid,
    Grid3X3,
    Group,
    Hand,
    Hash,
    Heart,
    HeartPulse,
    HelpCircle,
    Hexagon,
    History,
    Home,
    Hospital,
    Image,
    Images,
    Import,
    Inbox,
    Infinity,
    Info,
    Key,
    Keyboard,
    Layers,
    Layout,
    LayoutDashboard,
    LayoutGrid,
    Lightbulb,
    LineChart,
    Link,
    List,
    ListChecks,
    ListTodo,
    Loader,
    Loader2,
    Locate,
    Lock,
    LogOut,
    Logs,
    Mail,
    Map,
    MapPin,
    Maximize,
    Maximize2,
    Menu,
    Merge,
    MessageCircle,
    MessageSquare,
    Mic,
    MicOff,
    Microscope,
    Milk,
    Minimize2,
    Minus,
    Monitor,
    Moon,
    MoreHorizontal,
    MoreVertical,
    Mouse,
    Move,
    Navigation,
    Network,
    Option,
    Package,
    PackageCheck,
    PackagePlus,
    PenTool,
    Pencil,
    Percent,
    Phone,
    PieChart,
    Pill,
    Pipette,
    Pin,
    Play,
    Plus,
    PlusCircle,
    Printer,
    QrCode,
    Radio,
    Radius,
    Ratio,
    Receipt,
    RefreshCw,
    Regex,
    Repeat,
    Replace,
    Ribbon,
    Rocket,
    RotateCcw,
    Route,
    Rows,
    Ruler,
    Save,
    Scale,
    Scan,
    ScanLine,
    Scissors,
    Scroll,
    Search,
    SearchX,
    Section,
    Send,
    SendHorizonal,
    Settings,
    Share,
    Shield,
    ShieldAlert,
    ShoppingBag,
    ShoppingCart,
    Shrink,
    Sidebar,
    Signature,
    Siren,
    Slash,
    SlidersHorizontal,
    Smartphone,
    Sofa,
    Sparkles,
    Split,
    Square,
    Stamp,
    Star,
    Stethoscope,
    StickyNote,
    Store,
    Sun,
    Sunrise,
    Syringe,
    Table,
    Tablet,
    Tablets,
    Tag,
    Target,
    Terminal,
    TestTube,
    Text,
    Ticket,
    Timer,
    Trash2,
    TrendingDown,
    TrendingUp,
    Truck,
    Type,
    TypeIcon,
    Undo,
    Undo2,
    Unlink,
    Unlock,
    Upload,
    User,
    UserCheck,
    UserCog,
    UserMinus,
    UserPlus,
    UserX,
    Users,
    Verified,
    Video,
    View,
    Volume,
    Wallet,
    Weight,
    Wifi,
    Wind,
    Workflow,
    Wrench,
    X,
    XCircle,
    Zap,
} from 'lucide-react';

const iconMap = {
    Activity,
    ActivityIcon,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    Archive,
    AreaChart,
    Armchair,
    ArrowDown,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowRightLeft,
    ArrowUp,
    Atom,
    Baby,
    Badge,
    BadgeCheck,
    Ban,
    Banknote,
    BarChart,
    BarChart3,
    Barcode,
    Beaker,
    Bed,
    BedDouble,
    Bell,
    BellOff,
    Bluetooth,
    Book,
    BookOpen,
    Box,
    Brain,
    Briefcase,
    Bug,
    Building,
    Building2,
    Calculator,
    Calendar,
    CalendarDays,
    CalendarPlus,
    CalendarRange,
    Camera,
    Check,
    CheckCheck,
    CheckCircle,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Chrome,
    Circle,
    CircleDot,
    CircleHelp,
    Clipboard,
    ClipboardCheck,
    ClipboardList,
    Clock,
    Cloud,
    CloudUpload,
    Code,
    Coffee,
    Cog,
    Columns,
    Combine,
    Command,
    Component,
    Computer,
    Contact,
    Container,
    Contrast,
    Copy,
    CreditCard,
    Cross,
    Crown,
    Currency,
    Database,
    Delete,
    Diamond,
    Diff,
    Dock,
    DollarSign,
    DoorOpen,
    Dot,
    Download,
    Drill,
    Droplet,
    Droplets,
    Ear,
    Edit,
    Edit2,
    Edit3,
    Expand,
    ExternalLink,
    Eye,
    EyeOff,
    File,
    FileCheck,
    FileDown,
    FileEdit,
    FileImage,
    FilePlus,
    FileSpreadsheet,
    FileText,
    Files,
    Film,
    Filter,
    Fingerprint,
    Flag,
    FlaskConical,
    Focus,
    FolderOpen,
    Forward,
    Fullscreen,
    Gauge,
    GlassWater,
    Grid,
    Grid3X3,
    Group,
    Hand,
    Hash,
    Heart,
    HeartPulse,
    HelpCircle,
    Hexagon,
    History,
    Home,
    Hospital,
    Image,
    Images,
    Import,
    Inbox,
    Infinity,
    Info,
    Key,
    Keyboard,
    Layers,
    Layout,
    LayoutDashboard,
    LayoutGrid,
    Lightbulb,
    LineChart,
    Link,
    List,
    ListChecks,
    ListTodo,
    Loader,
    Loader2,
    Locate,
    Lock,
    LogOut,
    Logs,
    Mail,
    Map,
    MapPin,
    Maximize,
    Maximize2,
    Menu,
    Merge,
    MessageCircle,
    MessageSquare,
    Mic,
    MicOff,
    Microscope,
    Milk,
    Minimize2,
    Minus,
    Monitor,
    Moon,
    MoreHorizontal,
    MoreVertical,
    Mouse,
    Move,
    Navigation,
    Network,
    Option,
    Package,
    PackageCheck,
    PackagePlus,
    PenTool,
    Pencil,
    Percent,
    Phone,
    PieChart,
    Pill,
    Pipette,
    Pin,
    Play,
    Plus,
    PlusCircle,
    Printer,
    QrCode,
    Radio,
    Radius,
    Ratio,
    Receipt,
    RefreshCw,
    Regex,
    Repeat,
    Replace,
    Ribbon,
    Rocket,
    RotateCcw,
    Route,
    Rows,
    Ruler,
    Save,
    Scale,
    Scan,
    ScanLine,
    Scissors,
    Scroll,
    Search,
    SearchX,
    Section,
    Send,
    SendHorizonal,
    Settings,
    Share,
    Shield,
    ShieldAlert,
    ShoppingBag,
    ShoppingCart,
    Shrink,
    Sidebar,
    Signature,
    Siren,
    Slash,
    SlidersHorizontal,
    Smartphone,
    Sofa,
    Sparkles,
    Split,
    Square,
    Stamp,
    Star,
    Stethoscope,
    StickyNote,
    Store,
    Sun,
    Sunrise,
    Syringe,
    Table,
    Tablet,
    Tablets,
    Tag,
    Target,
    Terminal,
    TestTube,
    Text,
    Ticket,
    Timer,
    Trash2,
    TrendingDown,
    TrendingUp,
    Truck,
    Type,
    TypeIcon,
    Undo,
    Undo2,
    Unlink,
    Unlock,
    Upload,
    User,
    UserCheck,
    UserCog,
    UserMinus,
    UserPlus,
    UserX,
    Users,
    Verified,
    Video,
    View,
    Volume,
    Wallet,
    Weight,
    Wifi,
    Wind,
    Workflow,
    Wrench,
    X,
    XCircle,
    Zap,
};

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}

export default Icon;
